type ToggleQuestionModalPayload =
  | { visible: false }
  | {
      visible: true;
      jobId: number;
      applicationId: number;
    };

const interviewQuestionsActions = {
  TOGGLE_QUESTIONS_MODAL: 'TOGGLE_QUESTIONS_MODAL',
  TOGGLE_FEEDBACK_MODAL: 'TOGGLE_FEEDBACK_MODAL',

  toggleQuestionsModal: (payload: ToggleQuestionModalPayload) => ({
    type: interviewQuestionsActions.TOGGLE_QUESTIONS_MODAL,
    payload,
  }),

  toggleFeedbackModal: (payload: boolean) => ({
    type: interviewQuestionsActions.TOGGLE_FEEDBACK_MODAL,
    payload,
  }),
};

export default interviewQuestionsActions;
